import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTableConfig} from 'exc-controls';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../filter-sort-service.service';
import {ActivatedRoute} from '@angular/router';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
  styles: []
})
export class DealerListComponent extends  ExcTranslation implements OnInit {

  dealerTableConfig: ExcTableConfig = new ExcTableConfig();
  searchValue: string = null;
  level = 1;
  data: any[] = [];
  levels: {Dealer1: [], Dealer2: [], Dealer3: []};
  pagings: {Dealer1: [], Dealer2: [], Dealer3: []};
  public sortValue: { key: 'asc' | 'desc' } | {} = {};
  public sortData: ExcSort[] = [];
  public filterData: ExcFilter[] =  [];
  @ViewChild('filterMenu') filterMenu;
  ratings: any[] = [];
  selectedRating;
  lstFilters: ExcFilter[] = [];
  isFirstCall = true;
  addMore = false;
  dataSort = {field: null, order: null};
  hierarchyOptions = [{value: 1, text: this.getGlobal('DealerLevel1Tip')},
                      {value: 2, text: this.getGlobal('DealerLevel2Tip')},
                      {value: 3, text: this.getGlobal('DealerLevel3Tip')}
  ];
  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService, private excFss: FilterSortService
              , private route: ActivatedRoute, private excSec: ExcSigninService) {
    super();
    const _self = this;
    _self.filterData =  [
      new ExcFilter(1, this.getGlobal('Followup'), 'DealerWVDiff', new ExcFilterCondition('=', true), 'fltOpen', 'Globals.WvThisWeek', false),
      new ExcFilter(1, this.getRessource('Dealer'), 'DealerInactive', new ExcFilterCondition('=', true), 'DealerInactive',  this.getRessource('Deactive'), false),
      new ExcFilter(1, this.getRessource('Dealer'), 'DealerInactive', new ExcFilterCondition('=', false), 'DealerActive', this.getRessource('Active'), true)


      ];
    _self.sortData = [
      new ExcSort('DealerLevel1', 0, this.excDss.getLabel('DealerLevel1'), 0)
      , new ExcSort('DealerLevel2', 0, this.excDss.getLabel('DealerLevel2'), 0)
      , new ExcSort('DealerLevel3', 0, this.excDss.getLabel('DealerLevel3'), 0)
      , new ExcSort('DealerName', 0, 'Globals.DealerName', 1)
      , new ExcSort('DealerRating', 0, 'Globals.DealerRating', 0)

    ];
    for (const x of _self.filterData) {
      x.Container = _self.filterData;
    }
    for (const x of _self.sortData) {
      x.Container = _self.sortData;
    }
    ExcCoreModule.on('Dealer_Reload', () => {
      _self.initialLoad();
    });
    _self.dealerTableConfig.OnRefresh = () => {
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnPageChanged = (pageNo) => {
      _self.dealerTableConfig.paging.pageNo = pageNo;
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnSearch = (searchValue) => {
      _self.searchValue = searchValue;
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnFilterClick = (event?) => _self.filterMenu.toggle(event);
    _self.dealerTableConfig.OnFilter = () => {
    };
    if (_self.excSec.isFeatured('CLI_DLR_CU')) {
      _self.dealerTableConfig.OnAdd = (event?) => _self.addDealer();
    }
  }

  addDealer() {
    const _self = this;
    const data = {Header:  {DealerLevel1: null, DealerLevel2: null, DealerLevel3: null, DealerRating: null, DealerName: null,
        DealerCountry: null, DealerZip: null, DealerCity: null, DealerStreet: null, DealerPhone: null,
        DealerEmail: null, DealerDocumentTreat: null, DealerID: null, DealerCategory: null, DealerComment: null, DealerWV: null}
        , Defaults: {}, IsFirstCall: _self.isFirstCall, AddMore: _self.addMore};
    ExcCoreModule.showModal(ModalDealerEditComponent, null, 'm-alt', data, false).subscribe( r => {
      if (r && r.proceed) {
        _self.isFirstCall = false;
        _self.addMore = r.addMore;
        const url = _self.excRest.computeUrl('DealerR_List', {});
        _self.excRest.put(url, r.dealer, {}, false).subscribe( ret => {
          if (ret && ret.rtval === 1000) {
            if (_self.addMore === true) {
              _self.addDealer();
            }  else {
           new ExcTab(ret.data.Header.DealerName, DealerDetailsComponent, ret.data.Header, ret.data.Header.DealerID, {
              Unique: true, ReloadParent: function () {
                // _self.initialLoad();
              }
            }, true).Open();
            }
          } else {
            ExcCoreModule.showModal(_self.getTranslation('Errors.' + ret.data[0].Error), this.getTranslation('Errors.HeaderCreate'), 's', null, true, []).subscribe(x => {
            });
          }
        });
      }
    });

  }

  setLevel(lvl) {
    this.level = lvl;
    this.data = this.levels['Dealer' + this.level];
    this.dealerTableConfig.paging = this.pagings['Dealer' + this.level];
  }

  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerR_List', {fts: this.searchValue == null ? '' : this.searchValue});
    let mi = _self.dealerTableConfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.filterData, this.sortData);
    mi.dataSort = {};
    if (this.dataSort.field !== null) {
      mi.dataSort[this.dataSort.field] = this.dataSort.order;

    }
    _self.dealerTableConfig.isLoading = true;

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.levels = ret.data;
        _self.pagings = ret.paging;
        _self.data = _self.levels['Dealer' + this.level];
        _self.dealerTableConfig.paging = _self.pagings['Dealer' + this.level];
        _self.ratings = ret.data.Ratings;
        _self.dealerTableConfig.isLoading = false;
      }
    });
  }
  ngOnInit() {
    const _self = this;
    const flt = _self.route.snapshot.paramMap.get('flt');
    if (flt !== null) {
      if (_self.excFss.ApplyPresetFilter(flt, _self.filterData)) {
        _self.dealerTableConfig.MetaInfo.dataFilter = {flt: flt};
      }
    }
    _self.initialLoad();

  }

  setSortValue() {
    this.dealerTableConfig.MetaInfo.dataSort = this.sortValue;
    this.dealerTableConfig.MetaInfo.dataFilter = this.selectedRating;
    this.filterMenu.hide();
    this.initialLoad();
  }
  getSortClass(f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        return 'fa-sort-up';
      } else {
        return 'fa-sort-down';
      }
    } else {
      return 'fa-sort';
    }
  }
  setSort (f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        this.dataSort.order = 'desc';
      } else {
        this.dataSort.order = 'asc';
      }
    } else {
      this.dataSort.field = f;
      this.dataSort.order = 'asc';
    }
    this.initialLoad();
  }
  resetSortValue() {
    this.dealerTableConfig.MetaInfo.dataFilter = {};
    this.dealerTableConfig.MetaInfo.dataSort = {};
    this.filterMenu.hide();
    this.selectedRating = '';
    this.excFss.ResetFilter(this.filterData, this.sortData);
    this.initialLoad();
  }

  showDealerDetails (data) {
    new ExcTab(data.DealerName , DealerDetailsComponent, {
      DealerID: data.DealerID,
    }, data.DealerID, {Unique: true}, true).Open();
  }
}
